// test1348
(1348 && 0);
